import { render, staticRenderFns } from "./MessageCenter.vue?vue&type=template&id=720b63fd&scoped=true"
import script from "./MessageCenter.vue?vue&type=script&lang=js"
export * from "./MessageCenter.vue?vue&type=script&lang=js"
import style0 from "./MessageCenter.vue?vue&type=style&index=0&id=720b63fd&prod&lang=scss&scoped=true"
import style1 from "./MessageCenter.vue?vue&type=style&index=1&id=720b63fd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720b63fd",
  null
  
)

export default component.exports